import { Component, OnInit } from "@angular/core";
import { DocumentsService } from "../../../../../auth/service/documents.service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../../auth/service";
import { locale as italian } from "../../../../../i18n/it";
import moment from "moment";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-staff-document-view",
  templateUrl: "./single-document.component.html",
  styleUrls: ["./single-document.component.scss"],
})
export class SingleDocumentComponent implements OnInit {
  public config: any;

  public contentHeader: IContentHeader;

  public document: any;

  public tableLimit: number = 10;

  public searchKeyword: string = "";

  public categories: any = [];

  public selectedCategory: string = "all";

  public currentDocument: any;

  public me: ICurrentUser;

  public idDocument: any;

  public tomorrow: any = moment().add(1, "d").format("YYYY-MM-DD");

  public filter_status_signature: number = 4;

  public filter_status_acception: number = 4;

  public values_filter_signature: Array<any> = this._documentService.documents_statuses_signatures.filter((item: any) => item.value < 3);

  public values_filter_acception: Array<any> = this._documentService.documents_statuses_acception.filter((item: any) => item.value < 3);

  constructor(
    public _documentService: DocumentsService,
    public _utilService: UtilsService,
    private _routerService: Router,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    public route: ActivatedRoute,
  ) {
    this._utilService.disableAutoHideLoading();
    this.config = {
      selectLimitItems: true,
      headerHeight: 30,
      rowHeight: 50,
      footerHeight: 60,
      scrollbarH: true,
    };
    this.idDocument = this.route.snapshot.paramMap.get("id");
  }

  async ngOnInit() {
    await this.loadDocuments();
    this.contentHeader = {
      headerTitle: this.document.title,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.DOCUMENTS_LIST,
            isLink: true,
            link: "/dashboard/documents-list",
          },
          {
            name: this.document.title,
            isLink: false,
          },
        ],
      },
    };

    this.me = await this._authenticationService.getCurrentUser();
    this.categories = await this._documentService.getCategoriesList();
    this._utilService.hideLoading();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadDocuments() {
    this.document = await this._documentService.getDocument(Number(this.idDocument));
    this.document.description = this.document.description?.includes("users/") ? "" : this.document.description;
  }

  documentList() {
    let items: any = this.document.user_data;

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (this.filter_status_signature < 4) {
      if (this.filter_status_signature == 3) {
        items = items.filter((item) => item.require_signature == 0);
      } else {
        items = items.filter((item) => item.signed == this.filter_status_signature && this.document.require_signature === 1);
      }
    }
    if (this.filter_status_acception < 4) {
      if (this.filter_status_acception == 3) {
        items = items.filter((item) => !item.require_acception);
      } else {
        items = items.filter((item) => item.having_read == this.filter_status_acception && this.document.require_acception === 1);
      }
    }

    if (keywords.length > 0) {
      items = items.filter((item: any) => item.complete_name?.toLowerCase().includes(keywords));
    }

    return items;
  }
}
